import { configureStore } from '@reduxjs/toolkit';
import adminReducer from './adminSlice';

const store = configureStore({
  reducer: {
    admin: adminReducer,
  },
});

// Persist admin state (token, id, name) to localStorage so refresh keeps auth
try {
  store.subscribe(() => {
    const state = store.getState();
    const adminState = state.admin;
    localStorage.setItem('adminState', JSON.stringify(adminState));
  });
} catch (err) {
  // In environments without localStorage (e.g., SSR), ignore
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
